{
  "switchIntervalCard": {
    "title": "Switch to yearly",
    "nowLabel": "Now",
    "afterRenewalLabel": "After renewal",
    "endsOn": "Ends {0}",
    "whatYouPay": "What you pay",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "taxWithRate": "Tax ({0}%)",
    "dueToday": "Due today",
    "checkoutButton": "Checkout",
    "couponApplied": " coupon applied!",
    "errorMessage": "Something went wrong. Try later.",
    "supportMessage": "Hi, I need help switching my billing interval.",
    "promoCode": {
      "placeholder": "Promo code",
      "applyText": "Apply"
    },
    "renewsAt": "Renews at {0}/{1}",
    "unusedDaysCredit": {
      "label": "Unused time on current plan ({0} days)",
      "value": "Applied as discount."
    },
    "prorationFootnote": "Good news! The prorated balance from your current subscription is automatically applied to lower your total."
  }
}
